// Motorization and finish cards share the same CBB product transition as colors.
(() => {
  if (window.FPConnectedProductCardsReady) return;
  window.FPConnectedProductCardsReady = true;
  const selector = 'fp-connected-product-cards [data-fp-connected-product-url]';

  function prefetch(event) {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest?.(selector);
    window.FPConnectedProductTransition?.schedulePrefetch(item);
  }

  document.addEventListener('pointerenter', prefetch, true);
  document.addEventListener('pointerleave', event => {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest?.(selector);
    if (item && !item.contains(event.relatedTarget)) window.FPConnectedProductTransition?.cancelScheduledPrefetch(item);
  }, true);

  document.addEventListener('click', event => {
    const item = event.target.closest?.(selector);
    if (!item || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (item.hasAttribute('aria-current')) { event.preventDefault(); return; }
    const transition = window.FPConnectedProductTransition;
    if (!transition) return; // Keep the real product URL usable.
    event.preventDefault();
    const block = item.closest('fp-connected-product-cards');
    transition.transition(item.href, item.dataset.fpConnectedProductId, {
      showLoading: block?.dataset.fpShowLoading === 'true',
      pendingItem: item,
    });
  });

  // The product form, after CBB confirmation, owns the final cart properties.
  document.addEventListener('submit', event => {
    const form = event.target.closest?.('product-form form.form-product');
    if (!form) return;
    const section = form.closest('.section-main-product');
    if (form.closest('product-form')?.dataset.fpProductId !== section?.dataset.fpProductId) {
      event.preventDefault();
      return;
    }
    form.querySelectorAll('[data-fp-product-property]').forEach(input => {
      input.value = input.dataset.fpAuthoritativeValue || '';
      input.disabled = !input.value;
    });
    const rope = form.querySelector('[name="properties[Lado da cordinha]"]');
    const selectedRope = section?.querySelector('[name="lado-corda"]:checked');
    if (rope) {
      rope.disabled = !selectedRope;
      rope.value = selectedRope?.value || '';
    }
  }, true);
})();
